import { render, staticRenderFns } from "./CreateClaimContactInfo.vue?vue&type=template&id=651937d5"
import script from "./CreateClaimContactInfo.vue?vue&type=script&lang=js"
export * from "./CreateClaimContactInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports